<template>
	<div class="">
		<el-form :model="form" label-width="80px" size="mini">
			<el-form-item label="方式">
				<el-select v-model="form.component" placeholder="">
					<el-option label="引用" value="quote"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="引用类型">
				<el-radio-group v-model="form.type" @change="typeChange">
					<el-radio label="normal">普通</el-radio>
					<el-radio label="emun">枚举</el-radio>
					<el-radio label="mount">挂载</el-radio>
					<el-radio label="moudles">引用模块</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-divider content-position="left">配置</el-divider>

			<template v-if="form.type=='emun'">
				<el-form-item label="字段">
					<div style="width: 500px;display: inline-block;">
						<emunlist v-model="form.field" @change="emunlistChange" />
					</div>
					<div style="display: inline-block;margin-left: 10px;">
						<el-button type="primary" @click="enableSelect=true">可选项</el-button>
					</div>
				</el-form-item>
				<el-form-item label="选择">
					<el-checkbox v-model="form.cascader" @change="checkboxChange">cascader</el-checkbox>
					<el-checkbox v-model="form.checkStrictly" @change="checkboxChange">checkStrictly</el-checkbox>
					<el-checkbox v-model="form.multiple" @change="checkboxChange">multiple</el-checkbox>
					<el-checkbox v-model="form.checkbox" @change="checkboxChange">checkbox</el-checkbox>
				</el-form-item>
			</template>
			<template v-if="form.type=='moudles'">
				<el-form-item label="模块">
					<div style="width: 500px;display: inline-block;">
						<el-select v-model="form.moudles" placeholder=""  @change="moudlesInput" filterable allow-create
							default-first-option clearable>
							<el-option label="staff" value="staff"></el-option>
							<el-option label="department" value="department"></el-option>
						</el-select>
						<!-- <el-input v-model="form.moudles" placeholder="" @change="moudlesInput"></el-input> -->
					</div>
					<div style="display: inline-block;margin-left: 10px;">
						<el-button type="primary" @click="enableSelect=true">可选项</el-button>
					</div>
				</el-form-item>
				<el-form-item label="选择">
					<el-checkbox v-model="form.multiple" @change="moudlesInput">multiple</el-checkbox>
				</el-form-item>
			</template>
			<template>
				<el-form-item label="功能">
					<el-checkbox v-model="form.search" @change="setChange">查询</el-checkbox>
					<el-checkbox v-model="form.penetrate" @change="setChange">穿透</el-checkbox>
					<el-checkbox v-model="form.unique" @change="setChange">唯一值</el-checkbox>
				</el-form-item>
			</template>

			<!-- 			<template>
				<el-form-item label="固定">
					<el-radio v-model="form.fixed" :label="false" @change="setChange">不固定</el-radio>
					<el-radio v-model="form.fixed" label="left" @change="setChange">左固定</el-radio>
					<el-radio v-model="form.fixed" label="right" @change="setChange">右固定</el-radio>
				</el-form-item>
			</template> -->
			<!-- 			<template>
				<el-form-item label="宽度">
					<el-input v-model="form.width" @change="setChange"></el-input>
				</el-form-item>
			</template> -->

			<el-form-item label="配置预览">
				<vJsoneditor v-model="form.param" height="400px" :options="{mode:'view'}" />
			</el-form-item>
		</el-form>
		<vxe-modal v-model="enableSelect" @show="enableSelectShow" width="600" height="400" show-footer title="可选项">
			<template #default>
				<el-checkbox-group v-model="enableSelectOption">
					<el-checkbox v-for="(item,index) in selectOption" :label="item.id" :key="index">{{item.label}}
					</el-checkbox>
				</el-checkbox-group>
			</template>
			<template #footer>
				<vxe-button status="primary" content="确认" @click="enableSelectSubmit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import emunlist from '@_system/components/formcomponents/common/select/emunlist/select.vue'
	import vJsoneditor from 'v-jsoneditor'
	export default {
		props: {
			edge: {
				default: () => {
					return null
				}
			},
			height: {
				type: String,
				default: () => {
					return "600"
				}
			}
		},
		data() {
			return {
				enableSelect: false,
				selectOption: [],
				enableSelectOption:[],
				form: {
					type: 'normal',
					component: 'quote',
					param: {},
					field: '',
					cascader: false,
					checkStrictly: false,
					multiple: false,
					search: false,
					penetrate: false,
					unique: false,
					moudles: '',

					// fixed:false,
					// width:100,
				}

			}
		},
		created() {

		},
		mounted() {
			// this.form = {
			// 	type: 'normal',
			// 	component: 'quote',
			// 	field: '',
			// 	moudles: '',
			// 	param: {}
			// }
			if (this.edge.getData()) {
				this.form = JSON.parse(JSON.stringify(this.edge.getData()))
			}
		},
		watch: {

		},
		computed: {

		},

		methods: {
			enableSelectShow() {
				if(this.form.type=='emun'){
					this.$api.emun.list({
						field: this.form.field
					}).then((res) => {
						this.selectOption = res
					})
				}
	
				if(this.form.type =='moudles'){
					this.$api[this.form.moudles].list().then((res) => {
						this.selectOption = res.list.map((item)=>{
							return {
								id:item.id,
								label:item.name
							}
						})
					})
				}
			},
			enableSelectSubmit() {
				this.getParam(this.form.type)
				this.enableSelect = false
			},
			typeChange(e) {
				this.getParam(e)
			},
			emunlistChange(e) {
				this.form.field = e
				this.getParam('emun')
			},
			checkboxChange() {
				this.getParam('emun')
			},
			setChange() {
				let param = {}
				param.search = this.form.search
				param.penetrate = this.form.penetrate
				param.unique = this.form.unique
				param.fixed = this.form.fixed
				param.width = this.form.width
				this.form.param = {
					...this.form.param,
					...param
				}
			},
			moudlesInput() {
				this.getParam('moudles')
			},
			getParam(e) {
				console.log(e,this.form,123123)
				let param = {}
				if (e == 'emun') {
					if(this.enableSelectOption.length>0){
						param.enableSelectOption = this.enableSelectOption
					}	
					param.type = 'emun'
					param.emunName = this.form.field
					param.cascader = this.form.cascader
					param.checkStrictly = this.form.checkStrictly
					param.multiple = this.form.multiple
					param.checkbox = this.form.checkbox
				}
				if (e == 'mount') {
					param.mount = true
					param.penetrate = true
				}
				if (e == 'moudles') {
					if(this.enableSelectOption.length>0){
						param.enableSelectOption = this.enableSelectOption						
					}
					param.multiple = this.form.multiple
					param.type = this.form.moudles
				}
				this.form.param = param
				this.setChange()
			},
			submit() {
				this.edge.replaceData(this.form)
				this.edge.appendLabel(this.form.component)
			}
		},
		components: {
			emunlist,
			vJsoneditor
		}
	}
</script>
